export default __webpack_public_path__ + "static/media/payroll.b47a0474.svg";